export const PHONE_REG_EXP = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
export const SSN_REG_EXP = /^(\d{3}|X{3})-(\d{2}|X{2})-(\d{4}|X{4})$/;
export const MASKED_SSN_REG_EXP = /^(X{3})-(X{2})-(\d{4}|X{4})$/;
export const ZIP_REG_EXP = /^\d{5}$/;
